import type { ReactNode } from 'react';

export const symbol_share_eta: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M521-237 379-379q-5-5-7-10t-2-11v-170q0-13 8.5-21.5T400-600q13 0 21.5 8.5T430-570v158l133 133q9 9 9 21t-9 21q-9 9-21 9t-21-9Zm406-227q-13 2-23-6t-12-21q-26-146-126.5-253T522-886q-13-3-21-13.5t-6-23.5q2-14 14-20t26-2q160 40 273.5 159.5T952-502q2 14-4.5 25T927-464Zm-161-1q-13 2-23-6t-14-21q-23-79-78.5-139T519-720q-12-5-18.5-15.5T497-758q3-12 14.5-18.5T535-778q93 33 160 105.5T788-504q4 14-2.5 25.5T766-465ZM401 0q-83 0-156-31.5t-127.5-86Q63-172 31.5-245T0-400q0-83 31.5-156t86-127.5Q172-738 245-769.5T401-801q13 0 21.5 8.5T431-771q0 13-8.5 21.5T401-741q-142 0-241.5 99.5T60-400q0 141 99.5 240.5T401-60q141 0 240.5-99.5T741-400q0-13 8.5-21.5T771-430q13 0 21.5 8.5T801-400q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T401 0Z"
		/>
	</svg>
);
